import { ActionOperatorEnum, AttributionModelTypeEnum, CategoryOperatorEnum, ConversionCountTypeEnum, GoalStatusEnum, GoalTypeEnum, GoalValueTypeEnum, LabelOperatorEnum, ValueOperatorEnum } from '@bingads-webui-campaign-react/goal-creation-shared-config';
// ToDo: use campaign-odata-schemas when MT is ready
export const autoGoalSchemaFieldName = {
  Name: 'Name',
  Category: 'Category',
  CategoryOperator: 'CategoryOperator',
  Action: 'Action',
  ActionOperator: 'ActionOperator',
  Label: 'Label',
  LabelOperator: 'LabelOperator',
  Value: 'Value',
  ValueOperator: 'ValueOperator',
  Id: 'Id',
  Type: 'Type',
  Status: 'Status',
  LookbackWindowInMinutes: 'LookbackWindowInMinutes',
  LookbackWindowInMinutesGroup: 'LookbackWindowInMinutesGroup',
  Day: 'Day',
  Hour: 'Hour',
  Min: 'Min',
  IsAccountLevel: 'IsAccountLevel',
  ConversionCountType: 'ConversionCountType',
  GoalValue: 'GoalValue',
  CurrencyCode: 'CurrencyCode',
  GoalValueType: 'GoalValueType',
  IsMainConversionGoal: 'IsMainConversionGoal',
  ViewThroughLookbackWindowinMinutes: 'ViewThroughLookbackWindowinMinutes',
  ViewThroughLookbackWindowinMinutesGroup: 'ViewThroughLookbackWindowinMinutesGroup',
  AttributionModelType: 'AttributionModelType',
};

export const autoGoalSettingSchema = {
  name: 'aut goal setting schema',
  type: 'object',
  properties: {
    [autoGoalSchemaFieldName.Name]: {
      type: 'string',
      minLength: 1,
    },
    [autoGoalSchemaFieldName.GoalValue]: {
      type: 'number',
      required: true,
      minimum: 0,
      maximum: 9999999,
    },
    [autoGoalSchemaFieldName.ViewThroughLookbackWindowinMinutes]: {
      type: 'integer',
      required: true,
      minimum: 0,
      maximum: 150,
    },
    [autoGoalSchemaFieldName.ViewThroughLookbackWindowinMinutesGroup]: {
      type: 'object',
      schema: {
        name: 'ViewThroughLookbackWindowinMinutesGroup Schema',
        type: 'object',
        properties: {
          [autoGoalSchemaFieldName.Day]: {
            type: 'integer',
            required: true,
            minimum: 0,
            maximum: 30,
          },

          [autoGoalSchemaFieldName.Hour]: {
            type: 'integer',
            minimum: 0,
            maximum: 23,
          },
          [autoGoalSchemaFieldName.Min]: {
            type: 'integer',
            minimum: 0,
            maximum: 59,
          },
        },
      },
    },
    [autoGoalSchemaFieldName.Category]: {
      type: 'string',
    },
    [autoGoalSchemaFieldName.CategoryOperator]: {
      type: 'string',
      enum: CategoryOperatorEnum,
    },
    [autoGoalSchemaFieldName.Action]: {
      type: 'string',
    },
    [autoGoalSchemaFieldName.ActionOperator]: {
      type: 'string',
      enum: ActionOperatorEnum,
    },
    [autoGoalSchemaFieldName.Label]: {
      type: 'string',
    },
    [autoGoalSchemaFieldName.LabelOperator]: {
      type: 'string',
      enum: LabelOperatorEnum,
    },
    [autoGoalSchemaFieldName.Value]: {
      type: 'object',
      nullable: true,
    },
    [autoGoalSchemaFieldName.ValueOperator]: {
      type: 'string',
      enum: ValueOperatorEnum,
    },
    [autoGoalSchemaFieldName.Id]: {
      type: 'integer',
      key: true,
      nullable: true,
    },
    [autoGoalSchemaFieldName.Type]: {
      type: 'string',
      enum: GoalTypeEnum,
    },
    [autoGoalSchemaFieldName.Status]: {
      type: 'string',
      enum: GoalStatusEnum,
    },
    [autoGoalSchemaFieldName.LookbackWindowInMinutes]: {
      type: 'integer',
      minimum: 0,
      maximum: 129600,
    },
    [autoGoalSchemaFieldName.LookbackWindowInMinutesGroup]: {
      type: 'object',
      schema: {
        name: 'LookbackWindowInMinutesGroup Schema',
        type: 'object',
        properties: {
          [autoGoalSchemaFieldName.Day]: {
            type: 'integer',
            required: true,
            minimum: 0,
            maximum: 90,
          },
          [autoGoalSchemaFieldName.Hour]: {
            type: 'integer',
            minimum: 0,
            maximum: 23,
          },
          [autoGoalSchemaFieldName.Min]: {
            type: 'integer',
            minimum: 0,
            maximum: 59,
          },
        },
      },
    },
    [autoGoalSchemaFieldName.IsAccountLevel]: {
      type: 'boolean',
    },
    [autoGoalSchemaFieldName.ConversionCountType]: {
      type: 'string',
      enum: ConversionCountTypeEnum,
      nullable: true,
    },
    [autoGoalSchemaFieldName.CurrencyCode]: {
      type: 'string',
    },
    [autoGoalSchemaFieldName.GoalValueType]: {
      type: 'string',
      enum: GoalValueTypeEnum,
    },
    [autoGoalSchemaFieldName.AttributionModelType]: {
      type: 'string',
      enum: AttributionModelTypeEnum,
    },
    [autoGoalSchemaFieldName.IsMainConversionGoal]: {
      type: 'boolean',
      nullable: true,
    },
  },
};
